module.exports = __webpack_public_path__ + "static/media/highlighted_yellow.02b46b7e.svg";